import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import vuetifyOptions from './vuetify/vuetify.options'
import store from './store';

import 'vuetify/dist/vuetify.min.css'
import router from './router'

loadFonts()

const app = createApp(App).use(router);
app.use(vuetify, vuetifyOptions);
app.use(router)
app.use(store)
app.mount('#app')